import { loadRemote, init, loadShareSync, preloadRemote } from "@module-federation/runtime";

import * as react from "react";
import * as reactDomClient from "react-dom/client";
import * as bwotyWebUiKit from "@bwoty-web/ui-kit";

export const loadSharedDep = loadShareSync;

export const initialize = async ({ remotes = [], plugins = [] } = {}) => {
  init({
    name: "idun",
    remotes,
    plugins: [
      ...plugins /* Add custom runtime plugin here "./runtimePlugin" */,
    ],
    shared: {
      react: {
        version: "18",
        lib: () => react,
        shareConfig: {
          singleton: true,
        },
      },
      "react-dom/client": {
        version: "18",
        lib: () => reactDomClient,
        shareConfig: {
          singleton: true,
        },
      },
      "@bwoty-web/ui-kit": {
        version: "0.0.1-beta.199",
        lib: () => bwotyWebUiKit,
        shareConfig: {
          singleton: true,
        },
      },
    },
  });

  await preloadRemote(remotes.map(({name}) => ({nameOrAlias: name})));
};

export const getModule = async (id) => {
  const module = await loadRemote(id, {
    from: "runtime",
  });

  return module;
};

export const getModules = async (modulesToParse = []) => {
  const modules = await Promise.all(
    modulesToParse.map(async ({ moduleId, ...rest }) => {
      const module = await getModule(moduleId);
      return {
        moduleId,
        module,
        ...rest,
      };
    }),
  );

  return modules;
};

export const getComponents = async ({
  componentstoParse = [],
  remotes = [],
  plugins = [],
} = {}) => {
  await initialize({ remotes, plugins });

  const modules = await getModules(componentstoParse);

  const components = modules.map(({ moduleId, module, props }) => ({
    moduleId,
    component: module.default,
    props,
  }));

  return components;
};
